import { render, staticRenderFns } from "./TextAreaFlyfood.vue?vue&type=template&id=440c1000"
import script from "./TextAreaFlyfood.vue?vue&type=script&lang=js"
export * from "./TextAreaFlyfood.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports